export { ReactComponent as PowerPointObject } from './svgs/power-point-object.svg';
